<ng-container [ngSwitch]="step" *ngIf="!initialDataLoading; else loadingScreen">
  <db-create-website-trial-install
    *ngSwitchCase="'install'"
    [companyName]="companyName"
    [regions]="regions"
    [hostedWebsitesCount]="hostedWebsitesCount"
    [hostedWebsitesLimit]="hostedWebsitesLimit"
    [userSubscription]="currentSubscription"
    (submitted)="createWebsite($event)">
  </db-create-website-trial-install>

  <db-website-install-loading-dialog
    *ngSwitchCase="'creationProcess'"
    [step3]="creationProcessStep"
    [insidePageContent]="false"></db-website-install-loading-dialog>
</ng-container>

<ng-template #loadingScreen>
  <db-loading-screen [pageBlocker]="true"></db-loading-screen>
</ng-template>
